$(document).ready(function() {
    $('.btn-async-w-refresh').click(function(e) {
        e.preventDefault();

        var req = $.ajax($(e.target).attr('href'));
        req.always(function() {
            location.reload();
        });
    });
});
module.export={};


//////////////////
// WEBPACK FOOTER
// ./src/modules/AsyncBtn/AsyncBtn.js
// module id = 23
// module chunks = 0